import React, { useContext, useRef } from "react";
import ChatContext from "../context";
import { sendRequest } from "../send-message";

const RegenerateButton = ({ messageId, originalPrompt }) => {
  const { store, updateData } = useContext(ChatContext);
  const storeRef = useRef(store);
  
  // Keep storeRef updated
  React.useEffect(() => {
    storeRef.current = store;
  }, [store]);

  const handleRegenerate = () => {
    if (!originalPrompt) return;

    // Keep the original response and add a new conversation thread
    const currentStore = storeRef.current;
    const newData = { ...currentStore };
    
    // Add the user's message again
    const userMessage = {
      messageId: newData.messages.length + 1,
      senderName: currentStore.name,
      content: originalPrompt,
      timestamp: new Date().toISOString(),
      originalPrompt: originalPrompt,
    };
    
    const updatedMessages = [...newData.messages, userMessage];
    newData.messages = updatedMessages;
    newData.isLoading = true;
    updateData(newData);
    storeRef.current = newData; // Update ref immediately

    // Regenerate response - use a callback that accesses the latest store
    const updateMessages = (message) => {
      // Use the ref to get the latest state, which should have the user message
      const latestStore = storeRef.current;
      const updatedData = { ...latestStore };
      const newMessage = {
        messageId: updatedData.messages.length + 1,
        senderName: "Zucky",
        content: message,
        timestamp: new Date().toISOString(),
      };
      updatedData.messages = [...updatedData.messages, newMessage];
      updatedData.isLoading = false;
      updateData(updatedData);
      storeRef.current = updatedData; // Update ref
    };

    sendRequest(originalPrompt, updateMessages, currentStore.messages);
  };

  // Only show for the last AI message
  const isLastMessage = store.messages[store.messages.length - 1]?.messageId === messageId;
  const isAIMessage = store.messages.find((m) => m.messageId === messageId)?.senderName === "Zucky";

  // Don't show if currently loading a new response, not the last message, not an AI message, or no original prompt
  // Note: We allow showing even if typewriter is still animating (that's just visual)
  if (store.isLoading || !isLastMessage || !isAIMessage || !originalPrompt) {
    return null;
  }

  return (
    <button
      onClick={handleRegenerate}
      className="px-4 py-2 text-sm font-semibold bg-gradient-to-b from-[#4940A9] to-[#AE2DC7] hover:from-[#5a4fba] hover:to-[#c03dd8] text-white rounded-lg transition-all flex items-center gap-2 shadow-md"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-4 h-4"
      >
        <polyline points="23 4 23 10 17 10"></polyline>
        <polyline points="1 20 1 14 7 14"></polyline>
        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
      </svg>
      Regenerate
    </button>
  );
};

export default RegenerateButton;
